import { render, staticRenderFns } from "./addresses-controls.vue?vue&type=template&id=03210a1e&"
import script from "./addresses-controls.vue?vue&type=script&lang=js&"
export * from "./addresses-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports